import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AccessTime as AccessTimeIcon } from "@mui/icons-material";
import {
  getTicketStatusColor,
  getTicketTimeElapsed,
  formatTicketDate,
  ticketStatus,
  getTicketPriorityColor,
} from "./action";
import { useSocketContext } from "context/SocketContext";

const TicketList = ({ filteredTickets }) => {
  const { ticketUnreadMap } = useSocketContext();
  const navigate = useNavigate();

  return (
    <TableContainer
      component={Paper}
      variant="outlined"
      sx={{
        backgroundColor: "black", // Black background
        borderColor: "#474747",
        color: "#D8D5CD", // Text color
        borderRadius: "16px",
      }}
    >
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#222" }}>
            {/* Dark gray header */}
            <TableCell sx={{ color: "#D8D5CD" }}>Ticket</TableCell>
            <TableCell sx={{ color: "#D8D5CD" }}>Status</TableCell>
            <TableCell sx={{ color: "#D8D5CD" }}>Priority</TableCell>
            <TableCell sx={{ color: "#D8D5CD" }}>Created</TableCell>
            <TableCell sx={{ color: "#D8D5CD" }}>Last Update</TableCell>
            <TableCell sx={{ color: "#D8D5CD" }}>Messages</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredTickets.length > 0 ? (
            filteredTickets.map((ticket) => (
              <TableRow
                key={ticket.ticketId}
                hover
                sx={{
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#333" }, // Row hover effect
                }}
                onClick={() => navigate(`/tickets/${ticket?.id ?? ""}`)}
              >
                <TableCell>
                  <Box>
                    <Typography variant="subtitle2" sx={{ color: "#9E9E9E" }}>
                      {ticket.ticketId}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#D8D5CD" }}>
                      {ticket.title}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell>
                  <Chip
                    label={
                      ticketStatus.find((item) => item.id === ticket.status)
                        ?.name ?? ""
                    }
                    color={getTicketStatusColor(ticket.status)}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "medium",
                      color: getTicketPriorityColor(ticket.priority),
                    }}
                  >
                    {ticket.priority}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <AccessTimeIcon
                      fontSize="small"
                      sx={{ color: "#D8D5CD" }}
                    />
                    <Typography variant="body2" sx={{ color: "#D8D5CD" }}>
                      {getTicketTimeElapsed(ticket.createdAt)}
                    </Typography>
                  </Box>
                  <Typography variant="caption" color="gray">
                    {formatTicketDate(ticket.createdAt)}
                  </Typography>
                </TableCell>
                <TableCell sx={{ color: "#D8D5CD" }}>
                  {formatTicketDate(ticket.updatedAt)}
                </TableCell>
                <TableCell sx={{ color: "#D8D5CD" }}>
                  {ticketUnreadMap[ticket.id] && <span>🟠</span>}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} align="center">
                <Typography variant="body2" color="gray" sx={{ py: 2 }}>
                  No tickets found matching your criteria
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TicketList;
